import { MainLayout } from 'layouts/MainLayout'
import { NextPageWithLayout } from 'next'
import Script from 'next/script'

const CookiePolicy: NextPageWithLayout = () => {
  return (
    <>
      <div
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        name='termly-embed'
        data-id='4089cef3-3640-453a-a3a4-a8e1132d264f'
        datatype='iframe'
      />

      <Script id='cookiePolicy' strategy='afterInteractive'>
        {`
          (function(d, s, id) {
            var js, tjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "https://app.termly.io/embed-policy.min.js";
            tjs.parentNode.insertBefore(js, tjs);
          }(document, 'script', 'termly-jssdk'));
        `}
      </Script>
    </>
  )
}

CookiePolicy.getLayout = page => {
  return <MainLayout>{page}</MainLayout>
}

export default CookiePolicy
